"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompatAnimatedView = exports.CompatView = void 0;
var react_native_1 = require("react-native");
Object.defineProperty(exports, "CompatView", { enumerable: true, get: function () { return react_native_1.View; } });
var AnimatedView = react_native_1.Animated.View;
exports.CompatAnimatedView = AnimatedView;
//# sourceMappingURL=CompatView.js.map